import {
  addStringNoLocale,
  getSourceUrl,
  addDatetime,
  saveSolidDatasetAt,
  setThing,
  createThing,
  removeThing,
  addUrl,
  getThingAll,
  getDatetime,
} from "@inrupt/solid-client";
import { useDataset, Table, TableColumn } from "@inrupt/solid-ui-react";
import React, { useState, useEffect } from "react";

import {
  CREATED_PREDICATE,
  QUOTE_CLASS,
  TEXT_PREDICATE,
  TYPE_PREDICATE,
} from "../../lib/predicates";

import DeleteQuoteButton from "./DeleteQuoteButton";

//TODO: app state not updating on delete!  GAH!  THree scene will update but this wont!

function PublicQuoteList({
  publicQuoteList,
  setPublicQuoteList,
  handlePublicQuoteList,
}) {
  // const { dataset, error } = useDataset(
  //   "https://storage.inrupt.com/0ceecbd1-59d2-4858-8e73-a819d5bdb943/commonplace-book/index.ttl"
  // );

  useEffect(() => {}, [publicQuoteList]);

  const quoteThings = publicQuoteList ? getThingAll(publicQuoteList) : [];
  // newest quotes first
  quoteThings.sort((a, b) => {
    return (
      getDatetime(b, CREATED_PREDICATE) - getDatetime(a, CREATED_PREDICATE)
    );
  });

  const thingsArray = quoteThings.map((t) => {
    return { dataset: publicQuoteList, thing: t };
  });

  const deleteQuote = async (quote) => {
    const quotesUrl = getSourceUrl(publicQuoteList);
    const updatedQuotes = removeThing(publicQuoteList, quote);
    const updatedDataset = await saveSolidDatasetAt(quotesUrl, updatedQuotes);
    // setPublicQuoteList(updatedDataset);
    handlePublicQuoteList(updatedDataset);
  };

  // if (error) return <div>failed to load</div>;
  // if (!dataset) return <div>loading...</div>;
  if (!thingsArray.length) return null;

  return (
    <div>
      <h3></h3>
      <span className="tasks-message">
        The public list has {quoteThings.length} items
      </span>
      <Table className="table" things={thingsArray}>
        <TableColumn property={TEXT_PREDICATE} header="Quote" />
        <TableColumn
          property={CREATED_PREDICATE}
          dataType="datetime"
          header="Created At"
          body={({ value }) => value.toDateString()}
        />
        <TableColumn
          property={TEXT_PREDICATE}
          header="Remove"
          body={() => <DeleteQuoteButton deleteQuote={deleteQuote} />}
        />
      </Table>
    </div>
  );
}

export default PublicQuoteList;
